import { Type } from 'class-transformer';
import { IsDefined, IsString, Equals, IsObject, ValidateNested, validate, IsEnum } from 'class-validator';
import { SourceClasses } from '../source-type.interface';
import { BulkImportConfigDto } from './bulk-import/bulk-import-data.dto';

export class BulkImportDto {
    @IsDefined()
    @IsString()
    @IsEnum(SourceClasses)
    class: SourceClasses.BULK_IMPORT;

    @IsDefined()
    @IsObject()
    @ValidateNested()
    config: BulkImportConfigDto;

    constructor(iBulkImportDto: BulkImportDto) {
        this.class = iBulkImportDto.class;
        this.config = BulkImportConfigDto.fromDocument(iBulkImportDto.config);
    }

    static fromDocument(iBulkImportDto: BulkImportDto) {
        if (!iBulkImportDto) return null;
        const bulkImportDto = new BulkImportDto(iBulkImportDto);
        return bulkImportDto;
    }
}
